import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form';

import { categoryOptionValues, resolveCategoryOptionLabel } from '../common/categoryOptions/CategoryOptions';
import Select from '../common/formInputs/Select';

const categoryOptions = categoryOptionValues.map(category => ({
    id: category,
    label: resolveCategoryOptionLabel(category),
}));

type CategoryInputProps = {
    name: string;
};

export const CategoryInput = ({ name }: CategoryInputProps) => (
    <div className='margin-bottom-20'>
        <label>
            <FormattedMessage id='intl-msg:category' />
        </label>
        <Field name={name} component={Select} options={categoryOptions} placeholderId='categories' />
    </div>
);
